import { CanActivateFn } from '@angular/router';
import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DevToolsGuardService } from '../games/shared/devtools-guard/devtools-guard.service';
import { DevToolsWarningStateService } from '../games/shared/devtools-guard/devtools-warning-state.service';

// Runs on navigation INTO any game route (see app.routes.ts) - catches devtools that was already
// open before "Play Now" was ever clicked, which the in-game listeners can only catch once inside
// the page. Same UI-deterrent caveat as everywhere else this session: it blocks the docked-panel/
// console-attach heuristics DevToolsGuardService checks, nothing more - see that service's own
// comments. Shows the same "SECURITY VIOLATION!" card every game uses in-page, via the shared
// state service + the single modal instance mounted at the app root (app.component.html) - the
// guard runs before any game component exists, so it has nowhere of its own to render one.
export const devToolsEntryGuard: CanActivateFn = () => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) return true;

  const devToolsGuard = inject(DevToolsGuardService);
  if (!devToolsGuard.isOpenNow()) return true;

  inject(DevToolsWarningStateService).show(
    'Unusual activity detected on your account. Please try again later.'
  );
  return false;
};
